<template>
    <va-create-layout>
        <AffordabilityExpenseEvent-form
            :title="title"
            :item="item"
        ></AffordabilityExpenseEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
